import { render, staticRenderFns } from "./dashboard-heading.vue?vue&type=template&id=3a009542&scoped=true&"
import script from "./dashboard-heading.vue?vue&type=script&lang=js&"
export * from "./dashboard-heading.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-heading.vue?vue&type=style&index=0&id=3a009542&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a009542",
  null
  
)

export default component.exports